import { put, take, takeLatest, select } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../../utils/request';
import moment from 'moment';
import { splitTimeOffRangeRequests } from '../../../../utils/timeOffRequests';

const getUserId = state => state.identity.legacyUserId;
const getCurrentCenterId = state => state.identity.centerId;

function * getSchedule (payload) {
  try {
    let userId = yield select(getUserId);

    if (!userId) {
      yield take('FETCH_PROFILE_SUCCESS');
      userId = yield select(getUserId);
    }

    const start = payload.start ? payload.start : moment().startOf('week').format('YYYY-MM-DD');
    const end = payload.end ? payload.end : moment().endOf('week').format('YYYY-MM-DD');
    const response = yield ktRequest.get(`schedule?employeeId=${userId}&start=${start}&end=${end}`, 'timecards');
    const { data: { shifts, timeOff } } = response;
    const timeOffRequests = splitTimeOffRangeRequests(timeOff);

    yield put(actions.fetchScheduleSuccess(shifts, timeOffRequests));
  } catch (error) {
    console.log(error);
    yield put(actions.fetchScheduleFailure(error));
  }
}

function * requestTimeOff (payload) {
  try {
    const { requestType, timeOffType, start, end, description } = payload;
    const centerId = yield select(getCurrentCenterId);
    const isAllDay = requestType.toLowerCase() === 'allday';
    const startTimeISO = moment(start).toISOString();
    const endTimeISO = moment(end).toISOString();

    const body = {
      timeOffType,
      description,
      allDay: isAllDay,
      startTime: startTimeISO,
      endTime: endTimeISO,
      centerId
    };

    const response = yield ktRequest.post(`time-off/request-time-off`, body, 'timecards');

    if (!response.ok) {
      const json = yield response.json();
      const { error } = json;
      throw new Error(error);
    }

    const json = yield response.json();
    const { data } = json;

    yield put(actions.requestTimeOffSuccess(data));
  } catch (error) {
    yield put(actions.requestTimeOffFaliure(error.message));
  }
}

export const employeeScheduleSagas = [
  takeLatest(types.FETCH_EMPLOYEE_SHIFTS_REQUEST, getSchedule),
  takeLatest(types.REQUEST_TIME_OFF_REQUEST, requestTimeOff)
];
